<template>
  <v-auto-numeric
    ref="field"
    v-model="value"
    :class="className"
    :value="value"
    :label="label"
    :placeholder="placeholder"
    :outlined="outlined"
    :shaped="false"
    :disabled="disabled"
    :prefix="prefix"
    :dense="true"
    :hint="hint"
    :persistent-hint="hint"
    :prepend-inner-icon="isRequired ? 'mdi-asterisk' : ''"
    :decimal-places="decimalPlaces"
    :empty-input-behavior="emptyInputBehavior"
    :minimum-value="minimumValue"
    :hide-details="hideDetails"
    :digit-group-separator="getSeparator()"
    @input="emitFormatted($event)"
  >
    <template slot="append">
      <span v-html="suffix" />
    </template>
  </v-auto-numeric>
</template>

<script lang="js">
import VAutoNumeric from '@/general/component/VAutoNumeric';
import {Separator} from "@/general/custom-types/CustomTypes";

export default {
  components: { VAutoNumeric },
  props: {
    isListFilter: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    vid: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: 0
    },
    outlined: {
      type: Boolean,
      default: true
    },
    shaped: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    decimalPlaces: {
      type: Number,
      default: 3
    },
    formattedInput: {
      type: String,
      default: () => ''
    },
    emptyInputBehavior: {
      type: [Number, String],
      default: 'null'
    },
    className: {
      type: String,
      default: ''
    },
    minimumValue: {
      type: Number,
      default: 0
    },
    allowDecimalPadding: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    digitGroupSeparator: {
      type: Separator,
      default: Separator.NoSeparator
    },
  },
  mounted() {
    // TODO: Nie emituje emptyInputBehavior na mounted, przez co wyswietla inna wartosc niz jest zemitowana. Mam nadzieje, ze ta zmiana nie zepsuje innych formularzy
    this.emitFormatted(this.value);
  },
  computed: {
    isRequired() {
      return this.rules.includes('required');
    }
  },
  methods: {
    setErrors(errors) {
      this.$refs.validationObserver.setErrors(errors);
    },
    emitFormatted($event) {
      if (
        $event === '' ||
        $event === null ||
        $event === 'null' ||
        $event === undefined ||
        $event === 'undefined'
      ) {
        this.$emit('input', this.emptyInputBehavior);
      } else {
        let value = $event.toString();
        if (value.includes(',')) {
          value = value.replace(',', '.');
        }
        if (value.includes(' ')) {
          value = value.replace(' ', '');
        }
        this.$emit('input', Number(value));
      }
    },
    getSeparator(){
      return Separator[this.digitGroupSeparator]
    }
  }
};
</script>

<style scoped></style>
